module.exports = {
    apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3005' : 'https://api2.pro-morze.com',
}
